type PreloadItemRelType = 'preload' | 'prefetch';

class MetaHandlerClass {
  document: Document;

  alreadyAddedItems: string[];

  metaTags: HTMLLinkElement[];

  constructor() {
    this.document = window.document;
    this.alreadyAddedItems = [];
    this.metaTags = [];
  }

  public addPrefetch(url: string | string[], as: 'image' | 'font' | 'video' | 'style' | 'script' | 'audio', mimeType?: string, rel: PreloadItemRelType = 'preload'): void {
    const urlsToAdd = Array.isArray(url) ? url : [url];

    urlsToAdd.forEach((urlToAdd) => {
      if (this.alreadyAddedItems.includes(urlToAdd)) return;

      const linkTag = document.createElement('link');

      linkTag.rel = rel;
      linkTag.href = urlToAdd;
      linkTag.as = as;

      if (mimeType) {
        linkTag.type = mimeType;
      }

      this.document.getElementsByTagName('head')[0].appendChild(linkTag);

      this.metaTags.push(linkTag);
      this.alreadyAddedItems.push(urlToAdd);
    });
  }

  public clearAll(): void {
    this.metaTags.forEach((metaTag) => {
      metaTag.remove();
    });

    this.metaTags = [];
    this.alreadyAddedItems = [];
  }
}

const MetaHandler = new MetaHandlerClass();

export default MetaHandler;
